import axios from "axios";
import {
  notificationFail,
  loadingAction,
  setForbiddenAction,
} from "../redux/actions/actions";
import store from "../redux/store";
import ENV from "../Environments";
import {
  doLogout,
  getAppId,
  getLoggedInUser,
  getTokenData,
  getUserId,
  getUserUUID,
  isSubUserLoggedIn,
  isVendor,
} from "../common/utility";
import { apiUrls } from "../constants/apiUrls";

const Axios = axios.create({
  baseURL: ENV.getBaseUrl(),
  timeout: 30000,
});

export default Axios;
const { dispatch } = store;

Axios.interceptors.request.use((config) => {
  //add loader
  if (!config.url.includes(apiUrls.saveScmCart)) dispatch(loadingAction(true));
  const loggedInUser = getLoggedInUser();
  let tokenDecoded = getTokenData();
  const accessToken = loggedInUser && loggedInUser.accessToken;
  const tokenType = loggedInUser && loggedInUser.tokenType;
  if (tokenType === undefined && accessToken) {
    config.headers["Authorization"] = accessToken;
  } else if (tokenType && accessToken && !config.skipAuth) {
    config.headers["Authorization"] = `${tokenType} ${accessToken}`;
  }
  if (loggedInUser && loggedInUser.userUuid) {
    // config.headers['USER-ID'] = "B0228107"//loggedInUser.userUuid;
  }

  config.headers["APP-ID"] = getAppId();
  config.headers["teams-platform-secure"] = "TEAM";
  config.headers["USER-ID"] = getUserId(tokenDecoded);
  if (!config.isLogout) {
    config.headers["UUID"] = getUserUUID(tokenDecoded);
  }
  if (config.sourceLob) {
    config.headers["sourceLob"] = config.sourceLob;
  }
  if (loggedInUser && loggedInUser.UUID) {
    config.headers["APP-ID"] = loggedInUser.appId;
    if (!config.isLogout) {
      config.headers["UUID"] = loggedInUser.UUID;
    }
  }
  if (isVendor()) {
    config.headers["vendor-id"] = loggedInUser.userUuid;
  }
  if (isSubUserLoggedIn() && config.useParentKey) {
    config.headers["USER-ID"] = tokenDecoded?.attributes?.parentId;
    config.headers["UUID"] = tokenDecoded?.attributes?.parentId;
  }

  return config;
});

const UNAUTHORIZED = 401;
const FORBIDDEN = 403;
Axios.interceptors.response.use(
  // success handler
  (response) => {
    //remove loader
    dispatch(loadingAction(false));
    return response.data;
  },
  // error handler
  async (error) => {
    const { status } = error?.response || {};
    const { errorMessage } = error?.response?.data || {};
    // Remove loader
    dispatch(loadingAction(false));
    dispatch(notificationFail(error, errorMessage));
    if (status === UNAUTHORIZED) {
      doLogout(status);
    }
    if (status === FORBIDDEN) {
      dispatch(setForbiddenAction(true));
    }
    return Promise.reject(error);
  }
);
